.vc-owner-crown-icon {
    color: var(--status-warning);
}